var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FieldError, FieldHint, FormLabel, SwitchInput, } from '..';
import cn from 'classnames';
import s from './styles.module.css.json';
export function SwitchField(_a) {
    var id = _a.id, name = _a.name, label = _a.label, hint = _a.hint, error = _a.error, required = _a.required, formLabelProps = _a.formLabelProps, value = _a.value, onChange = _a.onChange, switchInputProps = _a.switchInputProps;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s.switchField__flex },
            React.createElement("div", { className: s.switchField__switchInput },
                React.createElement(SwitchInput, __assign({}, switchInputProps, { name: name, value: value, onChange: onChange }))),
            React.createElement(FormLabel, __assign({}, formLabelProps, { htmlFor: id, required: required, className: cn(s.switchField__label, formLabelProps === null || formLabelProps === void 0 ? void 0 : formLabelProps.className), error: !!error }), label)),
        (hint || error) && (React.createElement("div", { className: s.switchField__below },
            error && React.createElement(FieldError, null, error),
            hint && React.createElement(FieldHint, null, hint)))));
}
//# sourceMappingURL=index.js.map